import { TRule } from '../../typings';

export const DELDO_STOCKLIST_RULESET: TRule[] = [
  {
    type: 'rule.map',
    sourceKey: "c.['EAN']",
    destination: 'product',
    targetKey: 'ean',
  },

  {
    type: 'rule.map',
    sourceKey: "c['IPCODE']",
    targetKey: 'manufacturerCode',
    destination: 'product',
    outputType: 'string',
  },
  {
    type: 'rule.condition',
    sourceKey: "c['IPCODE']",
    condition: 'equals',
    conditionValue: '',
    outputValue: "c['Article']",
    outputLogic: 'custom',
    destination: 'product',
    targetKey: 'manufacturerCode',
    outputType: 'string',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Stock']",
    destination: 'product',
    targetKey: 'qty',
    outputType: 'number',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Article']",
    destination: 'product',
    targetKey: 'supplierCode',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Per parcel']",
    destination: 'product',
    targetKey: 'packageQuantity',
    outputType: 'number',
  },
  {
    type: 'rule.condition',
    sourceKey: "c.['Per parcel']",
    condition: 'equals',
    conditionValue: '',
    outputLogic: 'custom',
    destination: 'product',
    targetKey: 'packageQuantity',
    outputValue: 1,
    outputType: 'number',
  },
  {
    type: 'rule.condition',
    sourceKey: "c.['Per parcel']",
    condition: 'equals',
    conditionValue: '0',
    outputLogic: 'custom',
    destination: 'product',
    targetKey: 'packageQuantity',
    outputValue: 1,
    outputType: 'number',
  },
];

// IMAMO JOŠ KOLONE DOT I DEMO pa bi i to tribali ubacit